var _rect, _path, _path2, _rect2, _g, _rect3, _rect4, _rect5, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPreviewTutorialPreview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "#616161"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-1094 -493C-1094 -494.104 -1093.1 -495 -1092 -495H10036C10037.1 -495 10038 -494.105 10038 -493V4595C10038 4596.1 10037.1 4597 10036 4597H-1092C-1093.1 4597 -1094 4596.1 -1094 4595V-493Z",
    fill: "#444444"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-1092 -494H10036V-496H-1092V-494ZM10037 -493V4595H10039V-493H10037ZM10036 4596H-1092V4598H10036V4596ZM-1093 4595V-493H-1095V4595H-1093ZM-1092 4596C-1092.55 4596 -1093 4595.55 -1093 4595H-1095C-1095 4596.66 -1093.66 4598 -1092 4598V4596ZM10037 4595C10037 4595.55 10036.6 4596 10036 4596V4598C10037.7 4598 10039 4596.66 10039 4595H10037ZM10036 -494C10036.6 -494 10037 -493.552 10037 -493H10039C10039 -494.657 10037.7 -496 10036 -496V-494ZM-1092 -496C-1093.66 -496 -1095 -494.657 -1095 -493H-1093C-1093 -493.552 -1092.55 -494 -1092 -494V-496Z",
    fill: "black",
    fillOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 800,
    transform: "translate(-79 -430)",
    fill: "#F4F6F8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_0_1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -345,
    width: 342,
    height: 516,
    rx: 10,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -54.5,
    y: -344.5,
    width: 341,
    height: 515,
    rx: 9.5,
    stroke: "#EEF2F5"
  })), /*#__PURE__*/React.createElement("foreignObject", {
    x: -95,
    y: -446,
    width: 427,
    height: 853
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(8px)",
      clipPath: "url(#bgblur_2_0_1_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    "data-figma-bg-blur-radius": 16,
    x: -79,
    y: -430,
    width: 395,
    height: 821,
    fill: "#29185E",
    fillOpacity: 0.41
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -63,
    y: -257,
    width: 359,
    height: 415,
    rx: 12,
    fill: "white"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.19727 5.56641H7.17773C7.42043 5.56641 7.61719 5.36965 7.61719 5.12695C7.61719 4.88426 7.42043 4.6875 7.17773 4.6875H2.19727C1.95457 4.6875 1.75781 4.88426 1.75781 5.12695C1.75781 5.36965 1.95457 5.56641 2.19727 5.56641Z",
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00586 6.44531H2.19727C1.95457 6.44531 1.75781 6.64207 1.75781 6.88477C1.75781 7.12746 1.95457 7.32422 2.19727 7.32422H6.00586C6.24855 7.32422 6.44531 7.12746 6.44531 6.88477C6.44531 6.64207 6.24855 6.44531 6.00586 6.44531Z",
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00586 8.20312H2.19727C1.95457 8.20312 1.75781 8.39988 1.75781 8.64258C1.75781 8.88527 1.95457 9.08203 2.19727 9.08203H6.00586C6.24855 9.08203 6.44531 8.88527 6.44531 8.64258C6.44531 8.39988 6.24855 8.20312 6.00586 8.20312Z",
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00586 9.96094H2.19727C1.95457 9.96094 1.75781 10.1577 1.75781 10.4004C1.75781 10.6431 1.95457 10.8398 2.19727 10.8398H6.00586C6.24855 10.8398 6.44531 10.6431 6.44531 10.4004C6.44531 10.1577 6.24855 9.96094 6.00586 9.96094Z",
    fill: "#29185E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8713 12.3892L12.6738 10.1918C13.5752 8.98778 13.4792 7.26832 12.3854 6.17443C12.1049 5.89392 11.7796 5.67442 11.4258 5.52226V3.36914C11.4258 3.2526 11.3795 3.14083 11.297 3.05842L8.36748 0.12873C8.2851 0.0463184 8.1733 0 8.05676 0L1.61133 0C0.722842 0 0 0.722842 0 1.61133L0 13.3887C0 14.2772 0.722842 15 1.61133 15H9.81445C10.7029 15 11.4258 14.2772 11.4258 13.3887V11.177C11.6473 11.0817 11.8575 10.96 12.0526 10.8135L14.2498 13.0107C14.3356 13.0965 14.4481 13.1394 14.5605 13.1394C14.673 13.1394 14.7855 13.0965 14.8712 13.0107C15.0429 12.8391 15.0429 12.5609 14.8713 12.3892ZM11.7639 9.90331C11.5097 10.1575 11.204 10.3414 10.8705 10.446C10.8603 10.4488 10.8502 10.4519 10.8403 10.4554C10.6385 10.5155 10.4268 10.5469 10.2102 10.5469C9.62329 10.5469 9.07148 10.3183 8.65649 9.90331C8.24147 9.48829 8.01293 8.93651 8.01293 8.34961C8.01293 7.7627 8.24147 7.21093 8.65649 6.79591C9.07148 6.38089 9.62329 6.15234 10.2102 6.15234C10.4268 6.15234 10.6386 6.18369 10.8405 6.24384C10.8503 6.24729 10.8602 6.2504 10.8704 6.25315C11.2039 6.35777 11.5097 6.54164 11.7639 6.79588C12.6206 7.65264 12.6206 9.04661 11.7639 9.90331ZM9.9254 2.92969H8.49609V1.50041L9.9254 2.92969ZM10.5469 13.3887C10.5469 13.7925 10.2183 14.1211 9.81445 14.1211H1.61133C1.20747 14.1211 0.878906 13.7925 0.878906 13.3887L0.878906 1.61133C0.878906 1.20747 1.20747 0.878906 1.61133 0.878906L7.61719 0.878906V3.36914C7.61719 3.61184 7.81394 3.80859 8.05664 3.80859H10.5469V5.29175C10.4358 5.27974 10.3235 5.27344 10.2102 5.27344C9.3885 5.27344 8.616 5.59342 8.03502 6.17443C7.454 6.75545 7.13402 7.52795 7.13402 8.34961C7.13402 9.1713 7.454 9.9438 8.03502 10.5248C8.616 11.1058 9.3885 11.4258 10.2102 11.4258C10.3235 11.4258 10.4358 11.4195 10.5469 11.4075V13.3887Z",
    fill: "#29185E"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_2_0_1_clip_path",
    transform: "translate(95 446)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -79,
    y: -430,
    width: 395,
    height: 821
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 800,
    fill: "white",
    transform: "translate(-79 -430)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -55,
    y: -345,
    width: 342,
    height: 516,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewTutorialPreview);
export default __webpack_public_path__ + "static/media/preview-tutorial-preview.b1a72ec093b4d5ed51ef54e4fe915cc7.svg";
export { ForwardRef as ReactComponent };